import React from 'react';
import {StyleSheet, Text, TextInput, View, ScrollView} from 'react-native';
import PhoneNumberInput from '../../../../components/general/PhoneNumberInput';

const CampGeneralInformation = ({camp, setCamp}) => {

    const updateCamp = (name, value) => {
        setCamp((prevState) => {
            const newState = {...prevState};

            if (value === '') {
                delete newState[name];
            } else {
                newState[name] = value;
            }
            return newState;
        });
    }

    return (
        <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
            <View style={styles.field}>
                <Text style={styles.title}>General Info</Text>
                <Text style={styles.subtitle}>Tell us more about your camp.</Text>
            </View>

            <View style={styles.inputContainer}>
                <Text style={styles.label}>Camp Name</Text>
                <TextInput
                    style={styles.input}
                    placeholder="official name of your camp"
                    value={camp.campName || ''}
                    onChangeText={(value) => updateCamp('campName', value)}
                    placeholderTextColor='grey'
                />
            </View>

            <View style={styles.inputContainer}>
                <Text style={styles.label}>Camp Website (Optional)</Text>
                <TextInput
                    style={styles.input}
                    placeholder="camp website"
                    value={camp.campWebsite || ''}
                    onChangeText={(value) => updateCamp('campWebsite', value)}
                    placeholderTextColor='grey'
                />
            </View>

            <PhoneNumberInput
                label="Contact Phone"
                value={camp.campPhone || ''}
                onChangeText={(digits) => updateCamp('campPhone', digits)}
                placeholder="(555) 123-4567"
                required
                allowEmpty={false}
                containerStyle={styles.inputContainer}
            />

            <View style={styles.inputContainer}>
                <Text style={styles.label}>Contact Email</Text>
                <TextInput
                    style={styles.input}
                    placeholder="contact email"
                    value={camp.contactEmail || ''}
                    onChangeText={(value) => updateCamp('contactEmail', value)}
                    placeholderTextColor='grey'
                />
            </View>

            <View style={styles.inputContainer}>
                <Text style={styles.label}>General Description</Text>
                <TextInput
                    style={[styles.input, styles.descriptionInput]}
                    placeholder="what would you like others to know about your camp"
                    value={camp.campDescription || ''}
                    onChangeText={(value) => updateCamp('campDescription', value)}
                    placeholderTextColor='grey'
                    multiline={true}
                />
            </View>
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    contentContainer: {
        paddingHorizontal: 120,
        paddingTop: 40,
        paddingBottom: 40,
    },
    field: {
        flexDirection: 'column',
        marginBottom: 30,
    },
    title: {
        fontSize: 35,
        color: 'black',
        fontWeight: '600',
        marginBottom: 10,
    },
    subtitle: {
        fontSize: 15,
        color: 'grey',
    },
    label: {
        fontSize: 16,
        color: '#333',
        marginBottom: 5,
        fontWeight: '500',
    },
    input: {
        height: 40,
        borderColor: '#ddd',
        borderWidth: 1,
        borderRadius: 8,
        paddingHorizontal: 10,
        backgroundColor: '#fff',
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 1},
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 1,
    },
    inputContainer: {
        marginBottom: 20,
    },
    descriptionInput: {
        height: 80,
        textAlignVertical: 'top',
    },
});

export default CampGeneralInformation;
